var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBulk = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M15.89 9.752c.386.248.386.751 0 1l-6.875 4.386a.8.8 0 0 1-.843 0l-6.883-4.387c-.385-.248-.385-.75 0-.999"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M1.29 7.63c-.386.248-.386.75 0 1l.671.427 6.204 3.96c.25.16.593.16.843 0l6.203-3.96.672-.428c.386-.248.386-.75 0-.999"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M15.89 5.508 9.008 1.121a.8.8 0 0 0-.843 0L1.289 5.508c-.385.248-.385.75 0 .999l.672.428 1.458.93 4.746 3.029c.25.161.593.161.843 0l4.745-3.028 1.458-.93.672-.429c.386-.248.386-.75 0-.999z"
})));
export default SvgBulk;